export default {
  htmlFontSize: 7,
  fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
  fontSize: 7,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: '40px',
    lineHeight: '52px'
  },
  h2: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: '32px',
    lineHeight: '40px'
  },
  h3: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '32px'
  },
  h4: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '24px'
  },
  h5: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px'
  },
  h6: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px'
  },
  subtitle1: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '24px'
  },
  subtitle2: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '24px'
  },
  body1: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px'
  },
  body2: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px'
  },
  caption: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px'
  },
  button: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px'
  }
};
